import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponse } from '@app/core.model';
import { CommonService } from '@app/services/common.service';
import { environment } from 'src/environments/environment';
import { Coupon, CouponResponse } from './managed-coupon.model';
@Injectable({
  providedIn: 'root',
})
export class ManagedCouponService {
  constructor(private http: HttpClient, private commonService: CommonService) {}
  //Coupon Service
  getCouponList(filter?: string) {
    let url = `${environment.baseAPIUrl}/coupons?`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<CouponResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  addCoupon(payload: Record<string, string | number>) {
    return this.http.post<APIResponse>(
      `${environment.baseAPIUrl}/coupons`,
      payload,
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }

  updateCoupon(payload: Coupon, id: string) {
    return this.http.put<APIResponse>(
      `${environment.baseAPIUrl}/coupons/${id}`,
      payload,
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }

  deleteCoupon(id: string) {
    return this.http.delete<APIResponse>(
      `${environment.baseAPIUrl}/coupons/${id}`,
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }
}
